import axios from "@/plugins/axios";

let url = "/api/console/giftishow";

export default {
    getBizmoney(data){
        return axios.get(`${url}/bizmoney`, data).then(result => result.data);
    },
}
